import PropTypes from 'prop-types'

const VeryImportantWords = (props: any) => {
    return (
        <div className='very-important-words'>
            {props.veryImportantWords.map((item: any, i: number) => (
                <u key={i}> {item} </u>
            ))}
        </div>
    )
}

export default VeryImportantWords

VeryImportantWords.propTypes = {
    veryImportantWords: PropTypes.array.isRequired
}
